import {
	Component,
	ojs,
	app,
	state,
} from "modular-openscriptjs";
import { dom } from "../../../fotastart";

// Components
import RelatedProductView from "../../Views/RelatedProductView";
import { eParse, empty } from "../../../helpers";
import { routes } from "../../../backendRoutes";

const h = app("h");
const api = app("api");
const broker = app("broker");
const $e = app("$e");

ojs(RelatedProductView);

export default class RelatedProducts extends Component {
	productList = {};
	productId = null;

	render(product, ...args) {
		this.productId = product?.id;

		if (!empty(this.productId)) {
			this.getRelatedProducts(this.productId);
		}

		return h.div(
			{
				id: `c-related-products-${product?.id}-holder`,
				class: "overflow-x-auto scrollbar-sm bs-container-px-rst d-flex gap-2 gap-lg-3 align-items-stretch pb-2",
			},
			...args
		);
	}

	async getRelatedProducts(productId) {
		let res = await api.get(
			`${routes.customerProducts}/${productId}/related-products`,
			{ page: 1 },
			{ silent: true }
		);

		if (!res) return broker.send($e.app.messages.noRelatedProducts);

		const products = res.data.products;

		if (empty(products)) {
			return broker.send($e.app.messages.noRelatedProducts);
		}

		broker.send($e.app.messages.relatedProductsFound);

		for (let k in products) {
			let product = products[k];
			const p = state(product);

			this.productList[`p-${product?.id}`] = p;

			h.RelatedProductView(p, {
				parent: dom.id(`c-related-products-${productId}-holder`),
				class: "bg-white rounded-3 shadow-sm p-2 h-100 related-product border border-light-subtle",
				style: "min-width: 250px; max-width: 250px;",
				$class: "d-block flex-grow-1",
			});
		}
	}

	$$ojs = {
		beforeRouteChange: () => {
			this.cleanUp();
		},
	};

	cleanUp() {
		super.cleanUp();
		this.productList = {};
		this.productId = null;
	}

	updateProducts(ed, event) {
		const { message } = eParse(ed);
		const product = message.get("product");

		if (!(`p-${product.id}` in this.productList)) return;

		if (event == $e.product.deleted) {
			this.productList[`p-${product.id}`].value = null;
			return;
		}

		this.productList[`p-${product.id}`].value = product;
	}

	$$product = {
		stored_deleted: (ed, event) => this.updateProducts(ed, event),
		is: {
			liked_unliked_bookmarked_notBookmarked: (ed, event) => {
				this.updateProducts(ed, event);
			},
		},
	};
}

ojs(RelatedProducts);
